import { useState, useEffect } from 'react';

export const useUserData = (supabase) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const { data: { user }, error: userError } = await supabase.auth.getUser();
        
        if (userError) throw userError;
        if (!user) {
          setUserData(null);
          return;
        }

        const { data, error: functionError } = await supabase
          .rpc('get_user_info', { user_id: user.id });

        if (functionError) throw functionError;
        setUserData(data);
      } catch (err) {
        console.error('Error fetching user data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();

    // Subscribe to auth state changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        fetchUserData();
      } else {
        setUserData(null);
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [supabase]);

  const updateAirtableToken = async (token) => {
    try {
      setLoading(true);
      setError(null);
  
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('User not found');
  
      const { data, error } = await supabase.functions.invoke('pat-update', {
        body: { new_pat: token },
        headers: {
          Authorization: `Bearer ${user.access_token}`
        }
      });
  
      if (error) throw error;
      if (!data.success) throw new Error(data.error || "PAT update failed");
  
      // Refresh user info (since `pat_status` may have changed)
      const { data: updatedData, error: refreshError } = await supabase
        .rpc('get_user_info', { user_id: user.id });
  
      if (refreshError) throw refreshError;
  
      setUserData(updatedData);
      return updatedData;
    } catch (error) {
      console.error('Error updating Airtable token:', error);
      setError(error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };
  

  return {
    userData,
    loading,
    error,
    updateAirtableToken
  };
};